import { ApplicationRef, ComponentFactoryResolver, ComponentRef, Injectable, Injector, Renderer2, RendererFactory2 } from '@angular/core';
import { PdfViewerComponent } from '../../components/pdf-viewer/pdf-viewer.component';

@Injectable({
  providedIn: 'root'
})
export class OverlapService {

  private componentRef: ComponentRef<PdfViewerComponent> | null = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {}

  showPdf(blob: Blob) {
    // Dynamically create the component
    const factory =
      this.componentFactoryResolver.resolveComponentFactory(PdfViewerComponent);
    this.componentRef = factory.create(this.injector);

    // Pass data to the component
    if (this.componentRef.instance) {
      this.componentRef.instance.loadPdf(blob);
    }

    // Attach to Angular's app root
    this.appRef.attachView(this.componentRef.hostView);

    // Add to the DOM
    const overlayContainer = document.getElementById('global-overlay-container');
    if (overlayContainer) {
      overlayContainer.appendChild(
        (this.componentRef.hostView as any).rootNodes[0]
      );
    }
  }

  closeOverlay() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
      this.componentRef = null;
    }
  }
}
